.panel {
  padding: var(--sp-5);
  border-radius: var(--r-lg);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
}

.chip {
  min-height: 32px;
  padding-inline: var(--sp-3);
  border-radius: var(--r-pill);
  border: 1px solid var(--c-border-subtle);
  background: var(--c-surface-sunken);
  color: var(--c-text-tertiary);
  font: var(--t-label-m);
  transition:
    color var(--dur-fast) var(--ease-standard),
    border-color var(--dur-fast) var(--ease-standard);
}

.chip[aria-pressed='true'] {
  color: var(--c-text-primary);
  border-color: var(--c-sacred);
}

.seedRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
}

.seed {
  font-variant-numeric: tabular-nums;
  font-family: var(--font-mono);
}

.badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding-inline: var(--sp-3);
  border-radius: var(--r-pill);
  background: var(--c-arcane-bg);
  color: var(--c-arcane);
  font: var(--t-label-m);
}

.block {
  padding: var(--sp-5);
  border-radius: var(--r-lg);
}

.cardBox {
  display: flex;
  justify-content: center;
}
